import { Point, Layer } from '../../../context/context';

export interface PointStyleHandlerProps {
    point: Point;
    global: {
        mapLayers: Layer[];
        activeLayerId: number | null;
    };
    editLayer: (updatedLayer: Layer, layerId: number) => void;
    setSelectedPoint: (point: Point | null) => void;
    setIsPointModalOpen: (open: boolean) => void;
}

export function handlePointStyleEdit({
    point,
    global,
    editLayer,
    setSelectedPoint,
    setIsPointModalOpen
}: PointStyleHandlerProps) {
    const { mapLayers } = global;
    
    // Find the layer that contains this point
    // First try using point.layerId if available, otherwise search all layers
    let layer = null;
    if (point.layerId !== undefined) {
        layer = mapLayers.find(l => l.layerId === point.layerId);
    }
    
    // If not found by layerId, search all layers for the point
    if (!layer) {
        layer = mapLayers.find(l => l.shapes.some(shape => shape.id === point.id));
    }
    
    if (layer) {
        const updatedShapes = layer.shapes.map(shape =>
            shape.id === point.id ? point : shape
        );

        const updatedLayer = {
            ...layer,
            shapes: updatedShapes
        };

        editLayer(updatedLayer, layer.layerId);
        setSelectedPoint(null);
        setIsPointModalOpen(false);
    }
} 